export const RegistrationRegNoView = {

  init: function() {
    RegistrationRegNoView.validation();
  },
  validation: function() {
    $(document).ready(function(){
      $("#new_customer").validate({
        submitHandler: function(form) {
          $("input.btn").attr("disabled", true);
          form.submit();
        },
        rules: {
          'customer[country_code]': {
            required: true
          },
          'customer[ico]': {
            required: true
          }
        }
      });
    });
  }
}


export const RegistrationAddressView = {

  init: function() {

    if ($('#customer_vat_payer_true').is(':checked')) {
      $('#not-vat-payer-message').hide();
      $('#vat-payer-message').show();
    }
    else {
      $('#vat-payer-message').hide();
      $('#not-vat-payer-message').show();
    }

    RegistrationAddressView.vat_payer_sentence();
  },

  vat_payer_sentence: function() {
    $('#customer_vat_payer_true').on('click.mixit', function () {
        $('#not-vat-payer-message').hide();
        $('#vat-payer-message').show();
    });
    $('#customer_vat_payer_false').on('click.mixit', function () {
        $('#vat-payer-message').hide();
        $('#not-vat-payer-message').show();
    });
  }
};
